const doc = [({"en":({"js":({"admin":({"invoice_lines":({"create_card":({"create_invoice_line":"Create invoice line", "invoice_line_was_created":"The invoice line was created"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;